<template lang="pug">

v-snackbar(
  auto-height,
  bottom,
  v-model='open',
  :timeout='6000'
  ) {{ message }}
  v-btn(flat, color='primary', @click.native='open = false') Sluiten
</template>

<script>
export default {
  data () {
    return {
      open: false,
      message: null
    }
  },

  methods: {
    show (message) {
      this.message = message

      this.open = true
    },

    hide () {
      this.open = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
